// Task Editor 저장소·캐시·정규화.
// 정규화 자체는 `taskEditorUtils.normalizeTaskEditorStateShape` 가 책임.

import {
  normalizeTaskEditorStateShape,
  TaskEditorState,
} from "./taskEditorUtils";

// ─── 정규화 ───────────────────────────────────────────────────────────────

export function normalizeTaskEditorState(
  value: TaskEditorState | unknown
): TaskEditorState {
  return normalizeTaskEditorStateShape(value);
}

export function isTaskEditorState(value: unknown): value is TaskEditorState {
  if (!value || typeof value !== "object") return false;
  const c = value as Record<string, unknown>;
  return (
    typeof c.task_id === "string" &&
    typeof c.title === "string" &&
    Array.isArray(c.blocks)
  );
}

// ─── Task 캐시 ─────────────────────────────────────────────────────────────

let taskEditorTasksCache: Record<string, TaskEditorState> = {};

export function setTaskEditorTasksCache(
  tasks: Record<string, TaskEditorState>
) {
  taskEditorTasksCache = tasks;
}

export function getTaskEditorTasks(): Record<string, TaskEditorState> {
  return taskEditorTasksCache;
}

export function getTaskEditorTask(taskId: string): TaskEditorState | undefined {
  const id = taskId.trim();
  if (!id) return undefined;
  return taskEditorTasksCache[id];
}

export function getTaskEditorTaskTitle(taskId: string): string | undefined {
  return getTaskEditorTask(taskId)?.title;
}

export function isTaskEditorTaskIdTaken(
  taskId: string,
  excludeTaskId?: string
): boolean {
  const id = taskId.trim();
  if (!id) return false;
  const excludeId = excludeTaskId?.trim();
  return Object.keys(taskEditorTasksCache).some(
    (key) => key === id && key !== excludeId
  );
}
